import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useGetTourPackageDetails } from '../hooks/useGetTourPackageDetails';
import '../scss/tour-package.scss';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { getAuthUser } from '../redux/selectors/getUser';
import { BookingsService } from '../services/bookings.service';
import { toast, ToastContainer } from 'react-toastify';
import { TourPackageCard } from '../components/TourpackageCard/TourPackageCard';

export const TourPackageDetails = () => {
    const { id } = useParams();
    const { data: tourPackage, isLoading, error } = useGetTourPackageDetails(id);
    const authUser = useSelector(getAuthUser);
    const navigate = useNavigate();

    console.log(`authUser:`, authUser);

    const bookTourPackage = async () => {
        if (!authUser) {
            navigate('/login/whatsapp');
            return
        }

        try {
            toast.info('Бронируем ваш тур...', {
                position: "bottom-center"
            });
            const response = await BookingsService.create({
                tourPackageID: id,
                customers: [
                    {
                        "gender": "M",
                        "user": {
                            "phone": authUser.phone,
                            "birthdate": authUser.birthdate
                        },
                        "IDCard": {
                            "name": "",
                            "iin": ""
                        },
                        "passport": {
                            "number": "",
                            "dateOfExpire": ""
                        }
                    }
                ]
            })
            console.log(response);
            toast.success('Бронь успешно создана');
            navigate(`/orders/${response.id}`);
        } catch (error) {
            console.log(error);
            toast.error('Ошибка при бронировании тура');
        }
    }


    if (isLoading) {
        return <div>Loading...</div>
    }
    if (error) {
        return <div>Error: {error.message}</div>
    }
    return (
        <section>
            <TourPackageCard tourPackage={tourPackage} />
            <div className='tour-package-button mt-4 flex gap-4'>
                <Button variant='contained' color='primary' onClick={bookTourPackage}>Забронировать</Button>
            </div>
            <ToastContainer />
        </section>
    )
}
